// extracted by mini-css-extract-plugin
export default {"selectedUserContainer":"bb0fab4f","resetIcon":"d1de15af","textarea":"a18a7ee8"};